import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import UpsellModal from '~/Common-Objects/UpsellModal'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import AutomationFunctions from './automationFunctions'
import segmentsHelper from '~/Classes/segments.jsx'
import SiteVars from '~/Classes/siteVars'
import TemplateImageLoader from './templateImageLoader.jsx'
import i18n from '~/i18n'
import Pipedrive from './integrations/pipedrive/option'
import GenericOption from './integrations/generic/option'
import SmsPhone from '~/pages/cp/includes/sms/phone'
import SmsIPhone from '../../includes/sms/iphone'
import TopupSms from '~/pages/cp/company/sms/topup'
import textFunctions from '~/Classes/textFunctions'
import StepStatsHolder from './stepStatsHolder'
import PermissionChecker from '~/Classes/permissions'
import axios from '~/data/http/axios'
import ManageSms from '~/pages/cp/includes/upgrade/sms'
import AutomationOptions from './options'

function checkActivationErrors(activateError, step, overrideBorder) {
    if (activateError && activateError != '' && !step.complete) {
        overrideBorder = true
        return 'incomplete'
    }
    return ''
}

@connect((store) => {
    return { permissionStore: store.permission, accountMaster: store.accountMaster }
})
class AutomationOption extends Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.topupSms = this.topupSms.bind(this)
        this.goTo = this.goTo.bind(this)
    }

    topupSms(e) {
        e.stopPropagation()
        if (this.props.accountMaster.accountMaster.SmsAccountBillingId) {
            const content = (
                <ManageSms
                    onFinish={async () => {
                        this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null))
                    }}
                />
            )
            this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', content, true, 500, null, null, true))
        } else {
            axios.get('/accountMaster/plan?type=2').then((res) => {
                const modal = (
                    <UpsellModal
                        inline={true}
                        plans={res.data.Plans}
                        feature={'sms'}
                        onUpgrade={() => {
                            this.props.dispatch(siteMaster.alterFullpage(null))
                        }}
                    />
                )
                this.props.dispatch(siteMaster.alterFullpage(modal))
            })
        }
    }

    goTo(e, path) {
        e.stopPropagation()
        this.props.saveAndGo(path)
    }

    render() {
        const { automationId } = this.props
        let className = ''
        // if (this.props.disabled) className += ' automationDisabled'
        // if (this.props.highlightStep) className += ' automationHighlight'
        var step = this.props.step
        var isRunning =
            this.props.automationStatus == 'Running' ||
            this.props.automationStatus == 'Starting' ||
            this.props.automationStatus == 'Archived' ||
            this.props.automationStatus === 'Errored' ||
            this.props.automationStatus === 'Testing'
        var hideDeleteButton = false
        var isDisabled = false
        if (isRunning || this.props.choosing) {
            //choosing a step for stuff like the redirect step. Hides controls
            hideDeleteButton = true
        }
        if (this.props.hideAllOptions) {
            hideDeleteButton = true
        }

        if (this.props.disabled) hideDeleteButton = true

        if (this.props.choosing && this.props.choosingSourceGuid == step.guid) {
            isDisabled = true
        }

        let stepStats = this.props.stepStats.find((s) => s.StepGuid == step.guid)
        let stepStatsQueued = stepStats?.Queued || 0
        let stepStatsProcessed = stepStats?.Processed || 0

        const stepStatsHolderProps = {
            automationStatus: this.props.automationStatus,
            step,
            automationId,
            disabled: this.props.disabled
        }

        let canViewContacts = PermissionChecker('subscribers', this.props.permissionStore.permissions, 'read')
        if (!canViewContacts) stepStatsHolderProps.disabled = true

        let statsQueuedHolder = (
            <StepStatsHolder type='queued' {...stepStatsHolderProps}>
                {stepStatsQueued}
            </StepStatsHolder>
        )
        let statsProcessedHolder = (
            <StepStatsHolder type='processed' {...stepStatsHolderProps}>
                {stepStatsProcessed}
            </StepStatsHolder>
        )

        var outerStyle = {}
        if (this.props.outerStyle) outerStyle = this.props.outerStyle
        var overrideBorder = false

        if (isDisabled) {
            outerStyle.opacity = 0.3
        }

        let automationStepBlockClasses = 'automationStepBlock automationOption '
        automationStepBlockClasses += checkActivationErrors(this.props.activateError, step, outerStyle, overrideBorder)

        if (this.props.disabled) automationStepBlockClasses += ' automationDisabled'
        if (this.props.highlightStep) automationStepBlockClasses += ' automationHighlight'
        if (this.props.highlightGreen) automationStepBlockClasses += ' green'

        const editStep = isDisabled ? undefined : () => this.props.editStep(this.props.step)

        if (step.type == 'email') {
            var stepLabel = 'Email'
            var stepIcon = (
                <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M12.1665 2.33337H2.83317C2.18884 2.33337 1.6665 2.85571 1.6665 3.50004V10.5C1.6665 11.1444 2.18884 11.6667 2.83317 11.6667H12.1665C12.8108 11.6667 13.3332 11.1444 13.3332 10.5V3.50004C13.3332 2.85571 12.8108 2.33337 12.1665 2.33337Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M13.3332 4.08337L8.10067 7.40837C7.92058 7.52121 7.71236 7.58105 7.49984 7.58105C7.28732 7.58105 7.0791 7.52121 6.899 7.40837L1.6665 4.08337'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            let backgroundImage = ''
            if (step.stepOptions?.campaign?.TemplateId) {
                backgroundImage =
                    SiteVars.repoEndPoint +
                    'userContent/' +
                    this.props.accountMaster.accountMaster.id +
                    '/templates/screenshots/template' +
                    step.stepOptions.campaign.TemplateId +
                    '.jpg'
            }
            return (
                <div id={this.props.id} className={className + ' automationStep email'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}
                        {!step.complete && (
                            <div>
                                <div className='emailPreview'>
                                    {backgroundImage && (
                                        <TemplateImageLoader
                                            key={step.stepOptions.campaign.TemplateId}
                                            imageUrl={backgroundImage}
                                        />
                                    )}
                                </div>
                                <div className='emailSubject'>
                                    <div className='automationToDoHolder'>
                                        {i18n.t('automation:add.prompts.defineAnEmail')}
                                    </div>
                                    {!hideDeleteButton && (
                                        <div
                                            className='automationStepRemove'
                                            onClick={(event) => {
                                                event.stopPropagation()
                                                this.props.removeStep(
                                                    this.props.stepsData,
                                                    this.props.dataId,
                                                    step.guid
                                                )
                                            }}
                                        >
                                            <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {step.complete && (
                            <div>
                                <div className='emailPreview'>
                                    <TemplateImageLoader
                                        key={step.stepOptions.campaign.TemplateId}
                                        imageUrl={backgroundImage}
                                    />
                                </div>
                                <div className='emailSubject'>
                                    <div>{step.stepOptions.subject.value}</div>
                                    {/* <div className="stepMeta">{step.stepOptions.fromAddress.value}</div> */}
                                    {!hideDeleteButton && (
                                        <div
                                            className='automationStepRemove'
                                            onClick={(event) => {
                                                event.stopPropagation()
                                                this.props.removeStep(
                                                    this.props.stepsData,
                                                    this.props.dataId,
                                                    step.guid
                                                )
                                            }}
                                        >
                                            <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {statsProcessedHolder}
                        {this.props.contactOnStep}
                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type === 'sms') {
            var stepLabel = 'SMS'
            var stepIcon = (
                <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M4.60817 12.0697C5.72151 12.6408 7.00222 12.7955 8.21952 12.5059C9.43682 12.2163 10.5107 11.5014 11.2475 10.4901C11.9844 9.47883 12.3358 8.2376 12.2385 6.99012C12.1412 5.74263 11.6015 4.57092 10.7167 3.68613C9.83194 2.80135 8.66023 2.26167 7.41274 2.16435C6.16526 2.06703 4.92403 2.41847 3.91273 3.15533C2.90144 3.8922 2.18657 4.96604 1.89697 6.18334C1.60736 7.40064 1.76205 8.68135 2.33317 9.79469L1.1665 13.2364L4.60817 12.0697Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M4.6665 7.40308H4.6738'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7 7.40308H7.00729'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.3335 7.40308H9.34079'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            return (
                <div id={this.props.id} className={className + ' automationStep sms'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}
                        {Boolean(step.stepOptions.subject.value) && Boolean(step.stepOptions?.campaign?.TemplateId) && (
                            <div className='smsPreview'>
                                <SmsIPhone from={step.stepOptions.subject.value} content={''} size='tiny' />
                            </div>
                        )}
                        {/* {(!Boolean(step.stepOptions.subject.value) || !Boolean(step.stepOptions.campaign.TemplateId)) && <div className="iconMedalHolder"><div className="icon-smartphone" /></div>} */}
                        <div className='smsSubject'>
                            <div>
                                Send An SMS from{' '}
                                <strong>
                                    {step.stepOptions.subject.value ? ` ${step.stepOptions.subject.value}` : ''}
                                </strong>
                            </div>
                            <div className='mar-t5 text-xsml text-heavy text-grey'>
                                {this.props.accountMaster.accountMaster.smsCredits} Credit Remaining
                            </div>
                            <Button
                                className='primary button-sml mar-t5'
                                text='Upgrade'
                                onClick={this.topupSms}
                            />
                            {!hideDeleteButton && (
                                <div
                                    className='automationStepRemove'
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                    }}
                                >
                                    <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                                </div>
                            )}
                        </div>
                        {statsProcessedHolder}
                        {this.props.contactOnStep}
                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type == 'notification') {
            var stepLabel = 'Notification'
            var stepIcon = (
                <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M2.25 6.41667L12.75 3.5V10.5L2.25 8.16667V6.41667Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.26659 9.80003C7.20531 10.0222 7.10087 10.2301 6.95923 10.4119C6.8176 10.5937 6.64155 10.7458 6.44113 10.8595C6.24071 10.9733 6.01985 11.0465 5.79115 11.0748C5.56246 11.1032 5.33041 11.0863 5.10826 11.025C4.8861 10.9637 4.6782 10.8593 4.49641 10.7177C4.31462 10.576 4.1625 10.4 4.04875 10.1996C3.935 9.99915 3.86184 9.77829 3.83344 9.54959C3.80505 9.3209 3.82197 9.08885 3.88326 8.8667'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            var outPutText = []
            if (step.complete) {
                //notifications
                outPutText.push(<span>{i18n.t('automation:add.options.notify')}</span>)
                step.stepOptions.toAddresses.forEach((address) => {
                    outPutText.push(
                        <span>
                            <strong>{address.value}</strong>
                        </span>
                    )
                    outPutText.push(<span>, </span>)
                })
                outPutText.splice(outPutText.length - 1, 1)
            }
            return (
                <div id={this.props.id} className={className + ' automationStep notification'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}
                        {!step.complete && (
                            <div className='automationToDoHolder'>
                                {i18n.t('automation:add.prompts.defineANotification')}
                            </div>
                        )}
                        {step.complete && <div>{outPutText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}
                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type == 'webhook') {
            var stepLabel = 'Webhook'
            var stepIcon = (
                <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M8.75 2.28735H12.25V5.78735'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M5.8335 8.70402L12.2502 2.28735'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M10.5 8.12069V11.6207C10.5 11.9301 10.3771 12.2269 10.1583 12.4456C9.9395 12.6644 9.64275 12.7874 9.33333 12.7874H2.91667C2.60725 12.7874 2.3105 12.6644 2.09171 12.4456C1.87292 12.2269 1.75 11.9301 1.75 11.6207V5.20402C1.75 4.8946 1.87292 4.59785 2.09171 4.37906C2.3105 4.16027 2.60725 4.03735 2.91667 4.03735H6.41667'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )
            var outPutText = ''
            if (step.complete) {
                outPutText = (
                    <span>
                        {i18n.t('automation:add.options.webhook') + ' '}
                        <strong>{step.stepOptions.url.value}</strong>
                    </span>
                )
            }

            return (
                <div id={this.props.id} className={className + ' automationStep webhook'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}

                        {step.complete == false && (
                            <div className='automationToDoHolder'>
                                {i18n.t('automation:add.prompts.defineAWebhook')}
                            </div>
                        )}
                        {step.complete == true && <div>{outPutText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type == 'condition') {
            var stepLabel = 'Condition'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M4.6665 12.25H1.74984L1.74984 9.33333'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.33333 12.25H12.25V9.33333'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7 1.16667L7 6.00833C6.99667 6.31904 7.05542 6.62728 7.17282 6.91497C7.29022 7.20266 7.4639 7.464 7.68367 7.68367L12.25 12.25'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M5.25 8.75L1.75 12.25'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )
            var outputText = ''

            if (step.complete) {
                if (step.stepOptions.triggerType.value == '0') {
                    //workflow campaign actions
                    var theEmail =
                        step.stepOptions.workflowEmailGuid.value !== 'ANY'
                            ? AutomationFunctions.getStepByGuid(
                                  step.stepOptions.workflowEmailGuid.value,
                                  this.props.allSteps
                              )
                            : null
                    var theEmailSubject = ''
                    if (theEmail && theEmail.stepOptions && theEmail.stepOptions.subject) {
                        theEmailSubject = theEmail.stepOptions.subject.value
                        theEmailSubject = textFunctions.checkForHtml(theEmailSubject)
                    } else if (step.stepOptions.workflowEmailGuid.value === 'ANY') {
                        theEmailSubject = i18n.t('automation:add.options.anyWorkflowCampaign')
                    }

                    outputText = theEmailSubject

                    let linkClickedValue = textFunctions.checkForHtml(step.stepOptions.linkClicked.value)

                    if (step.stepOptions.workflowEmailActionType.value == '0')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.opened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '1')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.notOpened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '2')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.anyLink', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '3')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.link', {
                                        subject: theEmailSubject,
                                        link: linkClickedValue
                                    })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '4')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLinks', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '5')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLink', {
                                        subject: theEmailSubject,
                                        link: linkClickedValue
                                    })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '6')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.replied', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                }

                if (step.stepOptions.triggerType.value == '1') {
                    //custom field values
                    var customFieldName = ''
                    var customFieldAction = step.stepOptions.customFieldAction.value
                    var customFieldValue = step.stepOptions.customFieldValue.value

                    var customField = this.props.customFieldsData.find(
                        (fd) => fd.value == step.stepOptions.customFieldId.value
                    )
                    if (customField) {
                        customFieldName = customField.label

                        var customFieldType = customField.fieldType
                        var segRules = segmentsHelper.getOperators('string')
                        if (customFieldType == 'TEXT') {
                            segRules = segmentsHelper.getOperators('string')
                        }
                        if (customFieldType == 'NUMBER') {
                            segRules = segmentsHelper.getOperators('int')
                        }
                        if (customFieldType == 'TRUE/FALSE' || customFieldType == 'BOOLEAN') {
                            segRules = segmentsHelper.getOperators('bool')
                        }
                        if (customFieldType == 'DATE') {
                            segRules = segmentsHelper.getOperators('date')
                            if (customFieldAction.indexOf('be') < 0 && customFieldAction.indexOf('blank') < 0) {
                                customFieldValue = DateTimeFunctions.formatDateTime(customFieldValue, 2)
                            } else {
                                customFieldValue = ''
                            }
                        }

                        var foundSegmentRule = segRules.find((sf) => sf.value == customFieldAction)
                        if (foundSegmentRule) customFieldAction = foundSegmentRule.label
                    }

                    customFieldValue = customFieldValue + ''
                    outputText = (
                        <span>
                            <strong>{customFieldName}</strong> {customFieldAction} <strong>{customFieldValue}</strong>
                        </span>
                    )
                }

                if (step.stepOptions.triggerType.value == '2') {
                    //segments
                    var segmentName = ''

                    var segment = this.props.segmentsData.find((sg) => sg.value == step.stepOptions.segmentId.value)
                    if (segment) {
                        segmentName = segment.label
                    }
                    segmentName = textFunctions.checkForHtml(segmentName)
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.options.segment', { name: segmentName })
                            }}
                        ></span>
                    )
                }
                if (step.stepOptions.triggerType.value == '3') {
                    //normal campaign actions
                    var theEmail = this.props.campaignsData.find((cp) => cp.value == step.stepOptions.campaignId.value)

                    var theEmailSubject = ''
                    var theReplyAddress = ''
                    if (theEmail && theEmail.label) {
                        theEmailSubject = theEmail.label
                        theReplyAddress = theEmail.replyAddress
                    }
                    theEmailSubject = textFunctions.checkForHtml(theEmailSubject)
                    outputText = theEmailSubject
                    var theLink = textFunctions.checkForHtml(step.stepOptions.linkClicked.value)

                    if (step.stepOptions.campaignId.value === '')
                        theEmailSubject = i18n.t('automation:add.options.anyCampaign')

                    if (step.stepOptions.workflowEmailActionType.value == '0')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.opened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '1')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.notOpened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '2')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.anyLink', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '3')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.link', {
                                        subject: theEmailSubject,
                                        link: theLink
                                    })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '4')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLinks', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '5')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLink', {
                                        subject: theEmailSubject,
                                        link: theLink
                                    })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '6') {
                        var mailbox
                        var monitoredReplyAddresses = AutomationFunctions.getMonitoredReplyAddresses(
                            this.props.mailboxes,
                            this.props.emailChannels
                        )

                        if (theReplyAddress) {
                            mailbox = AutomationFunctions.findMonitoredReplyMailbox(
                                theReplyAddress,
                                this.props.mailboxes,
                                this.props.emailChannels
                            )
                        }
                        if (step.stepOptions.campaignId.value == '-1') {
                            outputText = (
                                <div>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: i18n.t('automation:add.options.repliedAny')
                                        }}
                                    ></span>
                                    {!monitoredReplyAddresses.length && (
                                        <div className='text-red mar-t10 text-heavy'>
                                            No Mailboxes not being monitored{' '}
                                            <Button
                                                onClick={(e) => this.goTo(e, '/cp/company/mailboxes')}
                                                text='Setup'
                                                className='mar-l10 red outline'
                                            />
                                        </div>
                                    )}
                                </div>
                            )
                        } else {
                            outputText = (
                                <div>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: i18n.t('automation:add.options.replied', {
                                                subject: theEmailSubject
                                            })
                                        }}
                                    ></span>
                                    {!monitoredReplyAddresses.length ||
                                        (!!theReplyAddress && (!mailbox || !mailbox.active) && (
                                            <div className='text-red mar-t10 text-heavy'>
                                                {theReplyAddress || 'No Mailboxes'} not being monitored{' '}
                                                <Button
                                                    onClick={(e) => this.goTo(e, '/cp/company/mailboxes')}
                                                    text='Setup'
                                                    className='mar-l10 red outline'
                                                />
                                            </div>
                                        ))}
                                </div>
                            )
                        }
                    }

                    if (
                        step.stepOptions.workflowEmailActionFilterOperator &&
                        step.stepOptions.workflowEmailActionFilterOperator.value
                    ) {
                        var filter = ''
                        if (step.stepOptions.workflowEmailActionFilterOperator.value === '=')
                            filter += i18n.t('automation:add.condition.exactlyXView', {
                                view: step.stepOptions.workflowEmailActionFilterValue.value
                            })
                        if (step.stepOptions.workflowEmailActionFilterOperator.value === '>')
                            filter += i18n.t('automation:add.condition.atLeastXView', {
                                view: step.stepOptions.workflowEmailActionFilterValue.value
                            })
                        if (step.stepOptions.workflowEmailActionFilterOperator.value === '<')
                            filter += i18n.t('automation:add.condition.lessThanXView', {
                                view: step.stepOptions.workflowEmailActionFilterValue.value
                            })
                        outputText = (
                            <span>
                                {outputText} {filter}
                            </span>
                        )
                    }
                }

                if (step.stepOptions.triggerType.value == '7') {
                    var groupName = ''
                    var foundGroup = this.props.groupsData.find(
                        (gp) => gp.value == this.props.step.stepOptions.groupId.value
                    )
                    if (foundGroup) groupName = foundGroup.label
                    groupName = textFunctions.checkForHtml(groupName)
                    let subscriberState = this.props.step.stepOptions.subscriberState.value
                    subscriberState = textFunctions.checkForHtml(subscriberState)

                    var message = i18n.t('automation:add.condition.groupWithState')
                    message = message.replace(/\[groupName\]/g, '<strong>' + groupName + '</strong>')
                    message = message.replace(/\[subscriberState\]/g, '<strong>' + subscriberState + '</strong>')

                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: message
                            }}
                        ></span>
                    )
                }

                if (step.stepOptions.triggerType.value == '9') {
                    var formName = 'FORM NOT FOUND'
                    var form = this.props.forms.find((f) => f.id == this.props.step.stepOptions.formId?.value)
                    if (form) formName = form.formName
                    formName = textFunctions.checkForHtml(formName)

                    let message = ''
                    if (this.props.step.stepOptions.formActivity?.value === 'download') {
                        message = i18n.t('automation:add.condition.formDownload', { formName })
                    } else if (this.props.step.stepOptions.formActivity?.value === 'signup') {
                        message = i18n.t('automation:add.condition.formSignup', { formName })
                    }

                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: message
                            }}
                        ></span>
                    )
                }

                if (step.stepOptions.triggerType.value == '10') {
                    outputText = i18n.t('automation:add.condition.inOtherAutomation', {
                        count: step.stepOptions.otherAutomations?.value?.length || 0
                    })
                }

                if (step.stepOptions.triggerType.value == '11') {
                    const tag = step.stepOptions.tagId?.value
                        ? this.props.tags.find((t) => t.id === step.stepOptions.tagId.value)
                        : null
                    const tagOption = step.stepOptions.tagType?.value === 'has not' ? 'Does not have ' : 'Has '
                    if (tag) {
                        outputText = (
                            <div>
                                {tagOption} the <strong>{tag.tagName}</strong> Tag
                            </div>
                        )
                    } else {
                        outputText = `${tagOption} a Tag`
                    }
                }

                if (step.stepOptions.triggerType.value === '12') {
                    outputText = i18n.t('automation:add.condition.datetimeOption', {
                        beforeAfter:
                            step.stepOptions.dateBeforeAfter?.value === 'before'
                                ? i18n.t('automation:add.condition.before')
                                : i18n.t('automation:add.condition.after'),
                        datetime: DateTimeFunctions.formatDateTime(step.stepOptions.datetime?.value)
                    })
                }

                if (step.stepOptions.triggerType.value === '13') {
                    outputText = i18n.t('automation:add.condition.daysOfWeek', {
                        days: step.stepOptions.daysOfWeek?.value
                            ?.map((d) => i18n.t('automation:add.condition.days.day' + d))
                            .join(', ')
                    })
                }

                if (isNaN(step.stepOptions.triggerType.value)) {
                    const app = this.props.applications.find(
                        (a) =>
                            a.Application.options &&
                            a.Application.options.triggers &&
                            a.Application.options.triggers.some((t) => t.value === step.stepOptions.triggerType.value)
                    )
                    if (app) {
                        const trigger = app.Application.options.triggers.find(
                            (t) => t.value === step.stepOptions.triggerType.value
                        )
                        if (trigger)
                            outputText = (
                                <span>
                                    Check the <strong>{trigger.label}</strong> Status
                                </span>
                            )
                    }
                    if (!outputText) outputText = <span>Integration Not Found</span>
                }
            }
            return (
                <div className={className + ' automationStep condition'}>
                    <div className='automationStepLabel automationStepCondition'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}

                        {!step.complete && (
                            <div className='automationToDoHolder'>
                                {i18n.t('automation:add.prompts.defineACondition')}
                            </div>
                        )}
                        {step.complete && <div>{outputText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type == 'delay') {
            var stepLabel = 'Delay'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M2.9165 12.8334H11.0832'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M2.9165 1.16663H11.0832'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.91683 12.8333V10.3997C9.91676 10.0903 9.7938 9.79357 9.575 9.57483L7.00016 7L4.42533 9.57483C4.20652 9.79357 4.08356 10.0903 4.0835 10.3997V12.8333'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M4.0835 1.16663V3.60029C4.08356 3.90969 4.20652 4.20638 4.42533 4.42513L7.00016 6.99996L9.575 4.42513C9.7938 4.20638 9.91676 3.90969 9.91683 3.60029V1.16663'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )
            var outputText = ''
            var unitType = i18n.t(step.stepOptions.delay_unit.value)
            let delayValue = textFunctions.checkForHtml(step.stepOptions.delay_value.value)
            let delayHours = textFunctions.checkForHtml(step.stepOptions.delay_time_hours.value)
            let delayMins = textFunctions.checkForHtml(step.stepOptions.delay_time_mins.value)
            let delayDayOfMonth = textFunctions.checkForHtml(step.stepOptions.delay_dayOfMonth.value)
            let delayExactDate = textFunctions.checkForHtml(step.stepOptions.delay_exactDate.value)

            if (unitType.indexOf('next') < 0) {
                outputText = (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('automation:add.options.delayNext', { number: delayValue, unit: unitType })
                        }}
                    ></span>
                )
            }
            if (unitType == 'next_time') {
                outputText = (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('automation:add.options.delayNextTime', {
                                hour: delayHours,
                                minute:
                                    delayMins +
                                    ' ' +
                                    DateTimeFunctions.getTimeZone(step.stepOptions.delay_time_timezone?.value)
                            })
                        }}
                    ></span>
                )
            }
            if (unitType == 'next_day') {
                var theDays = step.stepOptions.delay_daysOfWeek.value.map((tD) => {
                    if (tD == '0') return i18n.t('sunday')
                    if (tD == '1') return i18n.t('monday')
                    if (tD == '2') return i18n.t('tuesday')
                    if (tD == '3') return i18n.t('wednesday')
                    if (tD == '4') return i18n.t('thursday')
                    if (tD == '5') return i18n.t('friday')
                    if (tD == '6') return i18n.t('saturday')
                })

                outputText = (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('automation:add.options.delayNextDay', { day: theDays.join(', ') })
                        }}
                    ></span>
                )
            }
            if (unitType == 'next_monthday') {
                outputText = (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('automation:add.options.delayNextMonthday', { day: delayDayOfMonth })
                        }}
                    ></span>
                )
            }
            if (unitType == 'next_yearday') {
                outputText = (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('automation:add.options.delayNextYearday', {
                                date: DateTimeFunctions.formatDateTime(delayExactDate, 2, false)
                            })
                        }}
                    ></span>
                )
            }
            return (
                <div className={className + ' automationStep delay'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}
                        {!step.complete && (
                            <div className='automationToDoHolder'>{i18n.t('automation:add.prompts.defineADelay')}</div>
                        )}
                        {step.complete && <div className='autoEmailTitle'>{outputText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type == 'wait') {
            var stepLabel = 'Wait'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M6.99984 12.8334C10.2215 12.8334 12.8332 10.2217 12.8332 7.00008C12.8332 3.77842 10.2215 1.16675 6.99984 1.16675C3.77818 1.16675 1.1665 3.77842 1.1665 7.00008C1.1665 10.2217 3.77818 12.8334 6.99984 12.8334Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M5.8335 8.75V5.25'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8.1665 8.75V5.25'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )
            var outputText = ''
            if (step.complete) {
                if (step.stepOptions.triggerType.value == '0') {
                    //workflow campaign actions
                    var theEmail =
                        step.stepOptions.workflowEmailGuid.value !== 'ANY'
                            ? AutomationFunctions.getStepByGuid(
                                  step.stepOptions.workflowEmailGuid.value,
                                  this.props.allSteps
                              )
                            : null
                    var theEmailSubject = ''
                    if (theEmail && theEmail.stepOptions && theEmail.stepOptions.subject) {
                        theEmailSubject = theEmail.stepOptions.subject.value
                        theEmailSubject = textFunctions.checkForHtml(theEmailSubject)
                    } else if (step.stepOptions.workflowEmailGuid.value === 'ANY') {
                        theEmailSubject = i18n.t('automation:add.options.anyWorkflowCampaign')
                    }
                    outputText = theEmailSubject
                    let linkValue = textFunctions.checkForHtml(step.stepOptions.linkClicked.value)
                    if (step.stepOptions.workflowEmailActionType.value == '0')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.opened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '1')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.notOpened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '2')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.anyLink', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '3')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.link', {
                                        subject: theEmailSubject,
                                        link: linkValue
                                    })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '4')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLinks', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '5')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLink', {
                                        subject: theEmailSubject,
                                        link: linkValue
                                    })
                                }}
                            ></span>
                        )
                }

                if (step.stepOptions.triggerType.value == '1') {
                    //custom field values
                    var customFieldName = ''
                    var customFieldAction = step.stepOptions.customFieldAction.value
                    var customFieldValue = step.stepOptions.customFieldValue.value

                    var customField = this.props.customFieldsData.find(
                        (fd) => fd.value == step.stepOptions.customFieldId.value
                    )
                    if (customField) {
                        customFieldName = customField.label

                        var customFieldType = customField.fieldType
                        var segRules = segmentsHelper.getOperators('string')
                        if (customFieldType == 'TEXT') {
                            segRules = segmentsHelper.getOperators('string')
                        }
                        if (customFieldType == 'NUMBER') {
                            segRules = segmentsHelper.getOperators('int')
                        }
                        if (customFieldType == 'TRUE/FALSE' || customFieldType == 'BOOLEAN') {
                            segRules = segmentsHelper.getOperators('bool')
                        }
                        if (customFieldType == 'DATE') {
                            segRules = segmentsHelper.getOperators('date')
                        }

                        var foundSegmentRule = segRules.find((sf) => sf.value == customFieldAction)
                        if (foundSegmentRule) {
                            customFieldAction = foundSegmentRule.label
                            var customFieldVal = foundSegmentRule.value

                            if (customFieldType == 'DATE') {
                                if (customFieldVal.length > 2) {
                                    customFieldAction = customFieldAction.replace(' x ', ' ' + customFieldValue + ' ')
                                    customFieldValue = ''
                                } else {
                                    customFieldValue = DateTimeFunctions.formatDateTime(customFieldValue, 2)
                                }
                            }
                        }
                    }
                    customFieldValue = customFieldValue + ''
                    outputText = (
                        <span>
                            <strong>{customFieldName}</strong> {customFieldAction} <strong>{customFieldValue}</strong>
                        </span>
                    )
                }

                if (step.stepOptions.triggerType.value == '2') {
                    //segments
                    var segmentName = ''

                    var segment = this.props.segmentsData.find((sg) => sg.value == step.stepOptions.segmentId.value)
                    if (segment) {
                        segmentName = segment.label
                    }
                    segmentName = textFunctions.checkForHtml(segmentName)
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.options.segments', { segment: segmentName })
                            }}
                        ></span>
                    )
                }
                if (step.stepOptions.triggerType.value == '3') {
                    //normal campaign actions
                    var theEmail = this.props.campaignsData.find((cp) => cp.value == step.stepOptions.campaignId.value)

                    var theEmailSubject = ''
                    if (theEmail && theEmail.label) theEmailSubject = theEmail.label
                    theEmailSubject = textFunctions.checkForHtml(theEmailSubject)
                    outputText = theEmailSubject
                    var theLink = textFunctions.checkForHtml(step.stepOptions.linkClicked.value)
                    if (step.stepOptions.campaignId.value === '')
                        theEmailSubject = i18n.t('automation:add.options.anyCampaign')
                    if (step.stepOptions.workflowEmailActionType.value == '0')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.opened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '1')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.notOpened', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '2')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.anyLink', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '3')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.link', {
                                        subject: theEmailSubject,
                                        link: theLink
                                    })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '4')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLinks', { subject: theEmailSubject })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.workflowEmailActionType.value == '5')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.openedNoLink', {
                                        subject: theEmailSubject,
                                        link: theLink
                                    })
                                }}
                            ></span>
                        )
                }

                if (step.stepOptions.triggerType.value == '7') {
                    var groupName = ''
                    var foundGroup = this.props.groupsData.find(
                        (gp) => gp.value == this.props.step.stepOptions.groupId.value
                    )
                    if (foundGroup) groupName = foundGroup.label

                    var message = i18n.t('automation:add.wait.groupWithState')

                    groupName = textFunctions.checkForHtml(groupName)
                    let subscriberStateValue = textFunctions.checkForHtml(
                        this.props.step.stepOptions.subscriberState.value
                    )

                    message = message.replace(/\[groupName\]/g, '<strong>' + groupName + '</strong>')
                    message = message.replace(/\[subscriberState\]/g, '<strong>' + subscriberStateValue + '</strong>')

                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: message
                            }}
                        ></span>
                    )
                }

                let app
                this.props.applications.forEach((a) => {
                    if (a.Application.appName === step.stepOptions.triggerType.value) app = a
                })

                if (app) {
                    let trigger = app.Application.options.triggers.find(
                        (t) => t.value === step.stepOptions.trigger.value
                    )
                    outputText = (
                        <div>
                            <img height='40' src={app.Application.appLogoUri} />
                            <div>
                                the <strong>{app.Application.appName}</strong> action{' '}
                                <strong>{trigger ? trigger.label : ''}</strong>
                            </div>
                        </div>
                    )
                }
            }
            return (
                <div className={className + ' automationStep autoWait'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}

                        {!step.complete && (
                            <div className='automationToDoHolder'>{i18n.t('automation:add.prompts.defineWaitFor')}</div>
                        )}
                        {step.complete && (
                            <div className='autoEmailTitle'>
                                {i18n.t('automation:add.prompts.waitHereUntil')} {outputText}
                            </div>
                        )}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}
                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type == 'action') {
            var stepLabel = 'Action'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M7 11.6666H12.25'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.55282 2.1128C9.78504 1.88058 10.1 1.75012 10.4284 1.75012C10.7568 1.75012 11.0718 1.88058 11.304 2.1128C11.5362 2.34502 11.6667 2.65998 11.6667 2.98838C11.6667 3.31679 11.5362 3.63175 11.304 3.86397L4.29815 10.8704C4.15937 11.0092 3.98783 11.1107 3.7994 11.1656L2.12407 11.6544C2.07387 11.669 2.02066 11.6699 1.97001 11.6569C1.91936 11.6439 1.87313 11.6176 1.83616 11.5806C1.79919 11.5437 1.77283 11.4974 1.75986 11.4468C1.74688 11.3961 1.74776 11.3429 1.7624 11.2927L2.25123 9.61738C2.30619 9.42916 2.40771 9.25783 2.5464 9.11922L9.55282 2.1128Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8.75 2.91663L10.5 4.66663'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )
            var outputText = ''

            if (step.complete) {
                //actions

                if (step.stepOptions.actionType.value == '0') {
                    var customFieldName = ''
                    var customField = this.props.customFieldsData.find(
                        (fd) => fd.value == step.stepOptions.customFieldId.value
                    )
                    if (customField) {
                        customFieldName = customField.label
                        customFieldName = textFunctions.checkForHtml(customFieldName)
                    }

                    if (step.stepOptions.customFieldId.increment) {
                        outputText = (
                            <span>
                                {step.stepOptions.customFieldId.increment === 'inc' ? 'Increment' : 'Decrement'}{' '}
                                <strong>{customFieldName}</strong> by{' '}
                                <strong>{step.stepOptions.customFieldValue.value}</strong>
                            </span>
                        )
                    } else {
                        let tmpVal = ''
                        if (Array.isArray(step.stepOptions.customFieldValue.value)) {
                            tmpVal = JSON.parse(JSON.stringify(step.stepOptions.customFieldValue.value)).join(', ')
                        } else {
                            tmpVal = step.stepOptions.customFieldValue.value
                            if (tmpVal == '{{CURRENT_DATE}}') tmpVal = 'The action date'
                        }
                        tmpVal = textFunctions.checkForHtml(tmpVal)

                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.actionUpdate', {
                                        field: customFieldName,
                                        value: tmpVal
                                    })
                                }}
                            ></span>
                        )
                    }
                }
                if (
                    step.stepOptions.actionType.value == '1' ||
                    step.stepOptions.actionType.value == '2' ||
                    step.stepOptions.actionType.value == '3' ||
                    step.stepOptions.actionType.value == '11'
                ) {
                    var groupName = ''
                    var foundGroup = this.props.groupsData.find(
                        (gp) => gp.value == this.props.step.stepOptions.groupId.value
                    )
                    if (foundGroup) {
                        groupName = foundGroup.label
                        groupName = textFunctions.checkForHtml(groupName)
                    }

                    if (step.stepOptions.actionType.value == '1')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.actionCopy', { group: groupName })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.actionType.value == '2')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.actionMove', { group: groupName })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.actionType.value == '3')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.actionDelete', { group: groupName })
                                }}
                            ></span>
                        )
                    if (step.stepOptions.actionType.value == '11')
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.options.actionUnsubscribeGroup', {
                                        group: groupName
                                    })
                                }}
                            ></span>
                        )
                }

                if (step.stepOptions.actionType.value == '4') {
                    outputText = <span>{i18n.t('automation:add.options.actionUnsubscribe')}</span>
                }
                if (step.stepOptions.actionType.value == '5') {
                    var groupName = '',
                        tStatus = i18n.t('In-Active')
                    if (
                        this.props.step.stepOptions.subscriberStatus &&
                        this.props.step.stepOptions.subscriberStatus.value == '1'
                    )
                        tStatus = i18n.t('Active')
                    var foundGroup = this.props.groupsData.find(
                        (gp) => gp.value == this.props.step.stepOptions.groupId.value
                    )
                    if (foundGroup) {
                        groupName = foundGroup.label
                        groupName = textFunctions.checkForHtml(groupName)
                    }
                    if (this.props.step.stepOptions.groupId.value == 'ALL') groupName = i18n.t('allGroups')
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.options.actionStatus', {
                                    status: tStatus,
                                    group: groupName
                                })
                            }}
                        ></span>
                    )
                }
                if (step.stepOptions.actionType.value == '6') {
                    outputText = <span>{i18n.t('automation:add.options.actionReset')}</span>
                }
                if (step.stepOptions.actionType.value == '7') {
                    outputText = <span>{i18n.t('automation:add.action.action7')}</span>
                }
                if (step.stepOptions.actionType.value == '8') {
                    outputText = <span>{i18n.t('automation:add.action.action8')}</span>
                }
                if (step.stepOptions.actionType.value == '9') {
                    let tag
                    if (step.stepOptions.tagId && step.stepOptions.tagId.value) {
                        tag = this.props.tags.find((t) => t.id == step.stepOptions.tagId.value)
                    }
                    outputText = (
                        <div>
                            <span>{i18n.t('automation:add.action.action9')}</span>
                            {!!tag && <div className='square-chip'>{tag.tagName}</div>}
                        </div>
                    )
                }
                if (step.stepOptions.actionType.value == '10') {
                    let tag
                    if (step.stepOptions.tagId && step.stepOptions.tagId.value) {
                        tag = this.props.tags.find((t) => t.id == step.stepOptions.tagId.value)
                    }
                    outputText = (
                        <div>
                            <span>{i18n.t('automation:add.action.action10')}</span>
                            {!!tag && <div className='square-chip'>{tag.tagName}</div>}
                        </div>
                    )
                }

                if (step.stepOptions.actionType.value == '11') {
                }

                if (step.stepOptions.actionType.value == '12') {
                    outputText = <span>{i18n.t('automation:add.action.action12')}</span>
                }
                if (step.stepOptions.actionType.value == '13') {
                    outputText = <span>{i18n.t('automation:add.action.action13')}</span>
                }
            }
            return (
                <div id={this.props.id} className={className + ' automationStep action'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}
                        {!step.complete && (
                            <div className='automationToDoHolder'>
                                {i18n.t('automation:add.prompts.defineAnAction')}
                            </div>
                        )}
                        {step.complete && <div>{outputText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}
                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type === 'split') {
            var stepLabel = 'Split'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M9.3335 1.75L11.6668 4.08333L9.3335 6.41667'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.6668 4.08337H2.3335'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M4.66683 12.25L2.3335 9.91671L4.66683 7.58337'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M2.3335 9.91663H11.6668'
                        stroke='currentColor'
                        strokeWidth='1.3125'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            var outPutText = (
                <span>
                    Split contacts into <strong>{step.steps?.length}</strong> lanes
                </span>
            )

            return (
                <div className={className + ' automationStep split'}>
                    <div className='automationStepLabel automationStepCondition'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}
                        {outPutText}
                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }

        if (step.type === 'combine') {
            var outPutText = (
                <span>
                    <strong>Combine Split</strong>
                </span>
            )
            return (
                <div id={this.props.id} className={className + ' autoCondition'} onClick={editStep} style={outerStyle}>
                    {statsQueuedHolder}
                    <div className='iconArrowsSplitHolder'>
                        <Icons icon='contract' color='#fff' style={{ width: 20, height: 20 }} />
                    </div>
                    <div>{outPutText}</div>
                    {!hideDeleteButton && (
                        <div
                            className='automationRemoveStep'
                            onClick={(event) => {
                                event.stopPropagation()
                                this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                            }}
                        >
                            <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                        </div>
                    )}
                    {statsProcessedHolder}
                    {this.props.contactOnStep}
                </div>
            )
        }

        if (step.type == 'goal') {
            var stepLabel = 'Goal'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M3.49984 5.24992H2.62484C2.23806 5.24992 1.86713 5.09627 1.59364 4.82278C1.32015 4.54929 1.1665 4.17836 1.1665 3.79159C1.1665 3.40481 1.32015 3.03388 1.59364 2.76039C1.86713 2.4869 2.23806 2.33325 2.62484 2.33325H3.49984'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M10.5 5.24992H11.375C11.7618 5.24992 12.1327 5.09627 12.4062 4.82278C12.6797 4.54929 12.8333 4.17836 12.8333 3.79159C12.8333 3.40481 12.6797 3.03388 12.4062 2.76039C12.1327 2.4869 11.7618 2.33325 11.375 2.33325H10.5'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M2.3335 12.8333H11.6668'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M5.8335 8.55164V9.91664C5.8335 10.2375 5.55933 10.4883 5.26766 10.6225C4.57933 10.9375 4.0835 11.8066 4.0835 12.8333'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8.1665 8.55164V9.91664C8.1665 10.2375 8.44067 10.4883 8.73234 10.6225C9.42067 10.9375 9.9165 11.8066 9.9165 12.8333'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M10.5 1.16675H3.5V5.25008C3.5 6.17834 3.86875 7.06858 4.52513 7.72495C5.1815 8.38133 6.07174 8.75008 7 8.75008C7.92826 8.75008 8.8185 8.38133 9.47487 7.72495C10.1313 7.06858 10.5 6.17834 10.5 5.25008V1.16675Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )
            var outputText = ''
            if (step.complete) {
                outputText = step.stepOptions.name.value
            }

            if (
                step.stepOptions.goalEndAction &&
                step.stepOptions.goalEndAction.value &&
                step.stepOptions.goalEndAction.value == '2'
            ) {
                if (step.stepOptions.goalEndAutomation && step.stepOptions.goalEndAutomation.value) {
                    let automation = this.props.automations.find(
                        (a) => a.id == step.stepOptions.goalEndAutomation.value
                    )
                    if (automation) {
                        let automationName = textFunctions.checkForHtml(automation.name)
                        if (step.stepOptions.triggerType.value == '6') {
                            outputText = (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.t('automation:add.goal.sendToAutomationOptionScore', {
                                            automation: automationName
                                        })
                                    }}
                                />
                            )
                        } else {
                            outputText = (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.t('automation:add.goal.sendToAutomationOption', {
                                            automation: automationName
                                        })
                                    }}
                                />
                            )
                        }
                    } else {
                        step.complete = false
                    }
                }
            }

            return (
                <div id={this.props.id} className={className + ' automationStep goal'}>
                    <div className='automationStepLabel automationStepGoal'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}

                        {!step.complete && (
                            <div className='automationToDoHolder'>{i18n.t('automation:add.prompts.defineAGoal')}</div>
                        )}
                        {step.complete && <div>{outputText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}

                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }
        if (step.type === 'score') {
            var stepLabel = 'Score'
            var stepIcon = (
                <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M2.25 9.33331L4.58333 11.6666L6.91667 9.33331'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M4.5835 11.6666V2.33331'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12.7502 4.66665L10.4168 2.33331L8.0835 4.66665'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M10.4165 2.33331V11.6666'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            return (
                <div id={this.props.id} className={className + ' automationStep score'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}

                        {step.complete == false && (
                            <div className='automationToDoHolder'>
                                {i18n.t('automation:add.condition.defineAScore')}
                            </div>
                        )}
                        {step.complete == true && <div>{i18n.t('automation:add.condition.score')}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }
        if (step.type === 'notification') {
            return (
                <div
                    id={this.props.id}
                    className={className + ' autoNotification'}
                    onClick={editStep}
                    style={outerStyle}
                >
                    {statsQueuedHolder}
                    <div className='iconMedalHolder'>
                        <Icons
                            icon='megaphone'
                            color='purple'
                            style={{ width: 32, height: 32, margin: '0 auto' }}
                        />
                    </div>
                    {step.complete == false && (
                        <div className='automationToDoHolder'>{i18n.t('automation:add.prompts.defineAWebhook')}</div>
                    )}
                    {step.complete == true && <div>{i18n.t('automation:add.condition.score')}</div>}
                    {!hideDeleteButton && (
                        <div
                            className='automationRemoveStep'
                            onClick={(event) => {
                                event.stopPropagation()
                                this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                            }}
                        >
                            <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                        </div>
                    )}
                    {statsProcessedHolder}
                    {this.props.contactOnStep}
                </div>
            )
        }
        if (step.type === 'redirect') {
            var stepLabel = 'Redirect'
            var stepIcon = (
                <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M1.1665 5.78735L2.9165 4.03735L4.6665 5.78735'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.58317 11.0374H4.08317C3.77375 11.0374 3.47701 10.9144 3.25821 10.6956C3.03942 10.4769 2.9165 10.1801 2.9165 9.87069V4.03735'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12.8335 9.28735L11.0835 11.0374L9.3335 9.28735'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M6.4165 4.03735H9.9165C10.2259 4.03735 10.5227 4.16027 10.7415 4.37906C10.9603 4.59785 11.0832 4.8946 11.0832 5.20402V11.0374'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            var completedText = i18n.t('automation:add.redirect.optionText')
            if (completedText && completedText.length) {
                completedText = completedText.replace(/\[GUID\]/g, step.stepOptions.redirectGuid.value)
            }

            return (
                <div id={this.props.id} className={className + ' automationStep redirect'}>
                    <div className='automationStepLabel automationStepAction'>
                        {stepIcon}
                        {stepLabel}
                    </div>
                    <div id={this.props.id} className={automationStepBlockClasses} onClick={editStep}>
                        {statsQueuedHolder}

                        {step.complete == false && (
                            <div className='automationToDoHolder'>
                                {i18n.t('automation:add.prompts.defineARedirect')}
                            </div>
                        )}
                        {step.complete == true && <div>{completedText}</div>}

                        {!hideDeleteButton && (
                            <div
                                className='automationStepRemove'
                                onClick={(event) => {
                                    event.stopPropagation()
                                    this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                                }}
                            >
                                <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                        {statsProcessedHolder}
                        {this.props.contactOnStep}

                        <div className='automationStepCircle'></div>
                    </div>
                </div>
            )
        }
        if (step.type == 'initial') {
            var stepLabel = 'When'
            var stepIcon = (
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        d='M2.33337 8.16656C2.22298 8.16693 2.11475 8.13598 2.02126 8.0773C1.92776 8.01861 1.85284 7.9346 1.80519 7.83502C1.75754 7.73545 1.73912 7.6244 1.75208 7.51478C1.76503 7.40515 1.80882 7.30145 1.87837 7.21572L7.65337 1.26572C7.69669 1.21572 7.75572 1.18193 7.82078 1.1699C7.88583 1.15787 7.95304 1.16832 8.01138 1.19952C8.06972 1.23072 8.11571 1.28083 8.14182 1.34162C8.16792 1.40241 8.17258 1.47027 8.15504 1.53406L7.03504 5.04572C7.00201 5.13411 6.99092 5.22919 7.00271 5.32281C7.01451 5.41643 7.04884 5.50579 7.10276 5.58322C7.15667 5.66066 7.22857 5.72386 7.31228 5.7674C7.39599 5.81094 7.48901 5.83353 7.58337 5.83322H11.6667C11.7771 5.83285 11.8853 5.8638 11.9788 5.92249C12.0723 5.98117 12.1472 6.06518 12.1949 6.16476C12.2425 6.26433 12.2609 6.37538 12.248 6.48501C12.235 6.59463 12.1912 6.69833 12.1217 6.78406L6.3467 12.7341C6.30338 12.7841 6.24435 12.8178 6.1793 12.8299C6.11424 12.8419 6.04703 12.8315 5.98869 12.8003C5.93036 12.7691 5.88436 12.719 5.85826 12.6582C5.83215 12.5974 5.82749 12.5295 5.84504 12.4657L6.96504 8.95406C6.99806 8.86567 7.00915 8.77059 6.99736 8.67697C6.98556 8.58335 6.95123 8.49399 6.89732 8.41656C6.8434 8.33912 6.7715 8.27592 6.68779 8.23238C6.60408 8.18884 6.51106 8.16625 6.4167 8.16656H2.33337Z'
                        stroke='currentColor'
                        strokeWidth='1.3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            )

            let stepArray = [this.props.step]
            if (this.props.step.triggerSteps) {
                stepArray = stepArray.concat(this.props.step.triggerSteps)
            }
            let outPutArray = []
            stepArray.forEach((subStep, stepIndex) => {
                stepStats = this.props.stepStats.find((s) => s.StepGuid == subStep.guid)
                stepStatsQueued = stepStats?.Queued || 0
                stepStatsProcessed = stepStats?.Processed || 0

                let initialStepStatsHolderProps = { ...stepStatsHolderProps }
                initialStepStatsHolderProps.step = subStep

                statsQueuedHolder = (
                    <StepStatsHolder type='queued' {...initialStepStatsHolderProps}>
                        {stepStatsQueued}
                    </StepStatsHolder>
                )
                statsProcessedHolder = (
                    <StepStatsHolder type='processed' {...initialStepStatsHolderProps}>
                        {stepStatsProcessed}
                    </StepStatsHolder>
                )

                var outputText = ''
                if (subStep.triggerType.value == '0') {
                    var groupName = ''
                    var foundGroup = this.props.groupsData.find((gp) => gp.value == subStep.stepOptions.groupId.value)
                    if (foundGroup) {
                        groupName = textFunctions.checkForHtml(foundGroup.label)
                    }
                    let subscriberStateValue =
                        subStep.stepOptions.subscriberState && subStep.stepOptions.subscriberState.value
                            ? textFunctions.checkForHtml(subStep.stepOptions.subscriberState.value)
                            : ''

                    if (subscriberStateValue) {
                        subscriberStateValue = i18n.t('automation:add.initial.render0WithState_' + subscriberStateValue)
                    }

                    if (subStep.stepOptions.subscriberState) {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render0WithState', {
                                        groupName,
                                        subscriberState: subscriberStateValue
                                    })
                                }}
                            ></span>
                        )
                    } else {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render0WithoutState', {
                                        groupName
                                    })
                                }}
                            ></span>
                        )
                    }
                }
                if (subStep.triggerType.value == '1') {
                    var groupName = ''
                    var segmentName = ''
                    var foundGroup = this.props.groupsData.find((gp) => gp.value == subStep.stepOptions.groupId.value)
                    if (foundGroup) {
                        groupName = textFunctions.checkForHtml(foundGroup.label)
                    }
                    if (subStep.stepOptions.groupId.value == '-1000') groupName = 'Any Group'
                    var foundSegment = this.props.segmentsData.find(
                        (sg) => sg.value == subStep.stepOptions.segmentId.value
                    )
                    if (foundSegment) {
                        segmentName = textFunctions.checkForHtml(foundSegment.label)
                    }
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render1', {
                                    groupName,
                                    segmentName
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '2') {
                    var groupName = ''
                    var segmentName = ''
                    var foundGroup = this.props.groupsData.find((gp) => gp.value == subStep.stepOptions.groupId.value)
                    if (foundGroup) {
                        groupName = textFunctions.checkForHtml(foundGroup.label)
                    }
                    if (subStep.stepOptions.groupId.value == '-1000') groupName = 'Any Group'
                    var foundSegment = this.props.segmentsData.find(
                        (sg) => sg.value == subStep.stepOptions.segmentId.value
                    )
                    if (foundSegment) {
                        segmentName = textFunctions.checkForHtml(foundSegment.label)
                    }
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render2', {
                                    groupName,
                                    segmentName
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '3') {
                    var groupName = ''
                    var customFieldName = ''
                    var foundGroup = this.props.groupsData.find((gp) => gp.value == subStep.stepOptions.groupId.value)
                    if (foundGroup) groupName = textFunctions.checkForHtml(foundGroup.label)
                    var foundCustomField = this.props.customFieldsData.find(
                        (cf) => cf.value == subStep.stepOptions.customFieldId.value
                    )
                    if (foundCustomField) customFieldName = textFunctions.checkForHtml(foundCustomField.label)

                    if (subStep.stepOptions.onBeforeDate.value == 'on') {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render3On', {
                                        groupName,
                                        customFieldName
                                    })
                                }}
                            ></span>
                        )
                    }
                    if (subStep.stepOptions.onBeforeDate.value == 'before') {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render3Before', {
                                        groupName,
                                        customFieldName,
                                        number: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateValue.value),
                                        unit: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateUnits.value)
                                    })
                                }}
                            ></span>
                        )
                    }
                    if (subStep.stepOptions.onBeforeDate.value == 'after') {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render3After', {
                                        groupName,
                                        customFieldName,
                                        number: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateValue.value),
                                        unit: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateUnits.value)
                                    })
                                }}
                            ></span>
                        )
                    }
                }
                if (subStep.triggerType.value == '4') {
                    var groupName = ''
                    var customFieldName = ''
                    var foundGroup = this.props.groupsData.find((gp) => gp.value == subStep.stepOptions.groupId.value)
                    if (foundGroup) groupName = textFunctions.checkForHtml(foundGroup.label)
                    var foundCustomField = this.props.customFieldsData.find(
                        (cf) => cf.value == subStep.stepOptions.customFieldId.value
                    )
                    if (foundCustomField) customFieldName = textFunctions.checkForHtml(foundCustomField.label)

                    if (subStep.stepOptions.onBeforeDate.value == 'on') {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render4On', {
                                        groupName,
                                        customFieldName
                                    })
                                }}
                            ></span>
                        )
                    }
                    if (subStep.stepOptions.onBeforeDate.value == 'before') {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render4Before', {
                                        groupName,
                                        customFieldName,
                                        number: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateValue.value),
                                        unit: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateUnits.value)
                                    })
                                }}
                            ></span>
                        )
                    }
                    if (subStep.stepOptions.onBeforeDate.value == 'after') {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render4After', {
                                        customFieldName,
                                        groupName,
                                        customFieldName,
                                        number: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateValue.value),
                                        unit: textFunctions.checkForHtml(subStep.stepOptions.onBeforeDateUnits.value)
                                    })
                                }}
                            ></span>
                        )
                    }
                }
                if (subStep.triggerType.value == '5') {
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render5', {
                                    link: textFunctions.checkForHtml(subStep.stepOptions.link.value)
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '6') {
                    var theEmail = this.props.campaignsData.find(
                        (cp) => cp.value == subStep.stepOptions.campaignId.value
                    )
                    var theEmailSubject = ''
                    var theReplyAddress = ''
                    var mailbox
                    if (theEmail && theEmail.label) {
                        theEmailSubject = theEmail.label
                        theReplyAddress = theEmail.replyAddress
                    }

                    if (theReplyAddress) {
                        mailbox = AutomationFunctions.findMonitoredReplyMailbox(
                            theReplyAddress,
                            this.props.mailboxes,
                            this.props.emailChannels
                        )
                    }

                    const monitoredReplyAddresses = AutomationFunctions.getMonitoredReplyAddresses(
                        this.props.mailboxes,
                        this.props.emailChannels
                    )

                    if (step.stepOptions.campaignId.value == '-1') {
                        outputText = (
                            <div>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.t('automation:add.initial.render6Any')
                                    }}
                                ></span>
                                {!monitoredReplyAddresses.length && (
                                    <div className='text-red mar-t10 text-heavy'>
                                        No mailboxes not being monitored{' '}
                                        <Button
                                            onClick={(e) => this.goTo(e, '/cp/company/mailboxes')}
                                            text='Setup'
                                            className='mar-l10 red outline'
                                        />
                                    </div>
                                )}
                                {!!monitoredReplyAddresses.length && (
                                    <div className='mar-t10'>
                                        This will trigger for campaign replies to: {monitoredReplyAddresses.join(', ')}
                                    </div>
                                )}
                            </div>
                        )
                    } else {
                        outputText = (
                            <div>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.t('automation:add.initial.render6', {
                                            subject: textFunctions.checkForHtml(theEmailSubject)
                                        })
                                    }}
                                ></span>
                                {!!theReplyAddress && (!mailbox || !mailbox.active) && (
                                    <div className='text-red mar-t10 text-heavy'>
                                        {theReplyAddress} not being monitored{' '}
                                        <Button
                                            onClick={(e) => this.goTo(e, '/cp/company/mailboxes')}
                                            text='Setup'
                                            className='mar-l10 red outline'
                                        />
                                    </div>
                                )}
                            </div>
                        )
                    }
                }
                if (subStep.triggerType.value == '8') {
                    var theEmail = this.props.campaignsData.find(
                        (cp) => cp.value == subStep.stepOptions.campaignId.value
                    )
                    var theEmailSubject = ''
                    if (theEmail && theEmail.label) theEmailSubject = theEmail.label

                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render8', {
                                    subject: textFunctions.checkForHtml(theEmailSubject)
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '9') {
                    var theEmail = this.props.campaignsData.find(
                        (cp) => cp.value == subStep.stepOptions.campaignId.value
                    )
                    var theEmailSubject = ''
                    if (theEmail && theEmail.label) theEmailSubject = theEmail.label

                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render9', {
                                    subject: textFunctions.checkForHtml(theEmailSubject)
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '7') {
                    let replacementText = subStep.stepOptions.url.value
                    if (replacementText == '') replacementText = 'Any Page'
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render7', {
                                    url: textFunctions.checkForHtml(replacementText)
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '20') {
                    console.log(subStep)
                    let foundEvent = this.props.siteTrackerEvents.find(
                        (f) => f.value == subStep.stepOptions.eventId.value
                    )
                    let eventName = ''
                    if (foundEvent) eventName = foundEvent.label
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render20', {
                                    eventName: eventName
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '12') {
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.campaignBounce')
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '10') {
                    outputText = <span>{i18n.t('automation:add.initial.render10')}</span>
                }
                if (subStep.triggerType.value == '11') {
                    outputText = <span>{i18n.t('automation:add.initial.render11')}</span>
                }
                if (subStep.triggerType.value == '13') {
                    if (subStep.stepOptions.groupId && subStep.stepOptions.groupId.value) {
                        let group = this.props.groupsData.find((g) => g.value == subStep.stepOptions.groupId.value)
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render13Group', {
                                        groupName: group ? textFunctions.checkForHtml(group.label) : ''
                                    })
                                }}
                            ></span>
                        )
                    } else {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{ __html: i18n.t('automation:add.initial.render13') }}
                            ></span>
                        )
                    }
                }
                if (subStep.triggerType.value == '14') {
                    let automation

                    outputText = <span>{i18n.t('automation:add.initial.render14')}</span>
                }
                if (subStep.triggerType.value == '15') {
                    var theEmail = this.props.campaignsData.find(
                        (cp) => cp.value == subStep.stepOptions.campaignId.value
                    )
                    var theEmailSubject = ''
                    if (theEmail && theEmail.label) theEmailSubject = theEmail.label

                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render15', {
                                    subject: textFunctions.checkForHtml(theEmailSubject)
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '16') {
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render16')
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '17') {
                    if (
                        subStep.stepOptions.formId &&
                        subStep.stepOptions.formId.value &&
                        subStep.stepOptions.formId.value === '-1'
                    ) {
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render17Any')
                                }}
                            ></span>
                        )
                    } else {
                        let form = this.props.forms.find((f) => f.id == subStep.stepOptions.formId.value)
                        outputText = (
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('automation:add.initial.render17', {
                                        formName: form ? form.formName : 'FORM DELETED'
                                    })
                                }}
                            ></span>
                        )
                    }
                }
                if (subStep.triggerType.value == '18') {
                    const tag = this.props.linktags.find((t) => t.id === this.props.step.stepOptions.tagId.value)
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render18', {
                                    tag: tag ? tag.tagName : 'NOT FOUND'
                                })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '19') {
                    const form = this.props.forms.find((t) => t.id === this.props.step.stepOptions.formId.value)
                    const name =
                        this.props.step.stepOptions.formId.value === '-1' ? 'Any Form' : form?.formName || 'NOT FOUND'
                    outputText = (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('automation:add.initial.render19', { form: name })
                            }}
                        ></span>
                    )
                }
                if (subStep.triggerType.value == '21') {
                    outputText = (
                        <AutomationOptions.AutomationOptionChatClosed
                            chatIntents={this.props.chatIntents}
                            inboxes={this.props.inboxes}
                            stepOptions={this.props.step.stepOptions}
                        />
                    )
                }

                if (!parseInt(subStep.triggerType.value)) {
                    let app = this.props.applications.find((a) => a.Application.appName === subStep.triggerType.value)
                    if (this.props.isThemeDesigner && this.props.Application) {
                        app = { ApplicationId: this.props.Application.id, Application: this.props.Application }
                    }
                    if (app) {
                        let trigger = app.Application.options.triggers.find(
                            (t) => t.value === subStep.stepOptions.trigger.value
                        )
                        if (!trigger) {
                            subStep.complete = false
                        }
                        outputText = (
                            <div>
                                <img src={app.Application.appLogoUri} height='40' alt='' />
                                <div className='text-med text-heavy mar-b10'>{app.Application.appName}</div>
                                <div>{trigger ? trigger.label : 'Select Trigger'}</div>
                            </div>
                        )
                    }
                }
                let timerVal = ''
                if (
                    this.props.options &&
                    this.props.options.batchDelay &&
                    this.props.options.batchSize &&
                    this.props.options.batchUnit
                ) {
                    timerVal = (
                        <div style={{ position: 'absolute', top: 5, right: 8, cursor: 'pointer', fontSize: 18 }}>
                            <span className='icon-timer'></span>
                        </div>
                    )
                }
                outerStyle.flex = '1'
                outerStyle.display = 'flex'
                outerStyle.alignItems = 'center'
                outerStyle.maxWidth = '240px'
                outerStyle.marginLeft = '0px'
                outerStyle.marginRight = '0px'

                let isLast = stepIndex == stepArray.length - 1
                let isFirst = stepIndex == 0
                if (stepArray.length > 1) {
                    if (!isLast) outerStyle.marginRight = '16px'
                    if (!isFirst) outerStyle.marginLeft = '16px'
                }

                let posClass = ' '
                if (stepArray.length > 1) {
                    posClass = 'linesBelowFull '
                    if (isFirst) posClass = 'linesBelowLeft '
                    if (isLast) posClass = 'linesBelowRight '
                }
                let parentStep = this.props.stepsData
                let dataId = this.props.dataId
                if (stepIndex > 0) {
                    parentStep = this.props.step.triggerSteps
                    dataId = stepIndex - 1
                }

                let editableStep = subStep
                if (this.props.choosing) {
                    editableStep = this.props.step
                }

                let outerStyleC = { ...outerStyle }
                delete outerStyleC.border
                let innerStepStyle = {}

                let automationStepBlockClassesInitial = 'automationStepBlock '
                automationStepBlockClassesInitial += checkActivationErrors(
                    this.props.activateError,
                    subStep,
                    overrideBorder
                )

                const automationStatus = this.props.automationStatus

                outPutArray.push(
                    <div key={stepIndex} className={posClass + 'automationStep when'} style={outerStyleC}>
                        <div className='automationStepLabel automationStepWhen'>
                            {stepIcon}
                            {stepLabel}
                        </div>
                        <div
                            className={automationStepBlockClassesInitial}
                            onClick={() => (this.props.disabled ? {} : this.props.editStep(editableStep))}
                            style={innerStepStyle}
                        >
                            {timerVal}
                            {statsQueuedHolder}
                            {!subStep.complete && (
                                <div className='automationToDoHolder'>
                                    {i18n.t('automation:add.prompts.defineWorkflowTrigger')}
                                </div>
                            )}
                            {!isFirst && !hideDeleteButton && (
                                <div
                                    className='automationStepRemove'
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        this.props.removeStep(parentStep, dataId, step.guid)
                                    }}
                                >
                                    <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                                </div>
                            )}
                            {subStep.complete && <div>{outputText}</div>}
                            {statsProcessedHolder}
                            {this.props.contactOnStep}
                            <div className='automationStepCircle'></div>
                        </div>
                        {!isLast && (
                            <div style={{ position: 'absolute', right: '-23px', top: '50%', zIndex: '9999' }}>or</div>
                        )}
                        {!this.props.disabled &&
                            isLast &&
                            automationStatus !== 'Running' &&
                            automationStatus !== 'Starting' &&
                            automationStatus !== 'Archived' &&
                            automationStatus !== 'Errored' &&
                            automationStatus !== 'Testing' && (
                                <div
                                    style={{ position: 'absolute', top: 'calc(50% - 4px)', right: '-40px' }}
                                    className='automationAddStepButton mar-l15'
                                >
                                    <Icons
                                        icon='plus'
                                        style={{ display: 'flex' }}
                                        onClick={(ev) => this.props.addTrigger(ev)}
                                    />
                                </div>
                            )}
                    </div>
                )
            })
            return (
                <div
                    id={this.props.id}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: stepArray.length > 1 ? '32px' : ''
                    }}
                >
                    {outPutArray}
                </div>
            )
        }

        if (step.type == 'pipedrive') {
            return (
                <Pipedrive
                    id={this.props.id}
                    pipedrive={this.props.applications.find((a) => a.Application.appName === 'Pipedrive')}
                    style={overrideBorder ? outerStyle : undefined}
                    step={this.props.step}
                    steps={this.props.allSteps}
                    disabled={this.props.disabled}
                    editStep={this.props.disabled ? () => {} : this.props.editStep}
                    statsQueuedHolder={statsQueuedHolder}
                    statsProcessedHolder={statsProcessedHolder}
                    isRunning={isRunning}
                    removeStep={() => {
                        this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                    }}
                />
            )
        }

        if (parseInt(step.type)) {
            let accApp = this.props.applications.find((a) => a.ApplicationId === step.type)
            if (this.props.isThemeDesigner && this.props.Application) {
                accApp = { ApplicationId: this.props.Application.id, Application: this.props.Application }
            }
            return (
                <GenericOption
                    className={className}
                    id={this.props.id}
                    accApp={accApp}
                    step={step}
                    editStep={this.props.disabled ? () => {} : this.props.editStep}
                    steps={this.props.allSteps}
                    statsQueuedHolder={statsQueuedHolder}
                    statsProcessedHolder={statsProcessedHolder}
                    contactOnStep={this.props.contactOnStep}
                    isRunning={isRunning}
                    hideDeleteButton={hideDeleteButton}
                    removeStep={() => {
                        this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                    }}
                    isThemeDesigner={this.props.isThemeDesigner}
                />
            )
        }

        return <div id={this.props.id}></div>
    }
}

export default AutomationOption
